import styled from "styled-components";

export const Container = styled.div`
    display:flex;
    position: relative;
    height: 100vh;
    width: 100vw;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    max-width: 2530px;
    flex-direction: column;
    
    align-items:center;
    overflow: hidden;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 768px) and (max-width: 1360px) and (max-height: 800px) {
        overflow-y: auto;
        overflow-x: hidden;
    }
`;

export const BlackBottom = styled.div`
    background-color: #000;
    width: 100vw;
    flex: 1;
    flex-basis: 100%;
    @media (min-width: 319px) and (max-width: 767px) {
        display: none; 
    }
    @media (min-width: 768px) and (max-width: 1360px) {
        margin-top: 500px;
    }
`;

export const ScrollableArea = styled.div`
    display:flex;
    width: 100vw;
    margin: 0px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
`;


